import React from 'react';
import styled from 'styled-components';
import MultiStepActivationContainer from './Components/MultiStepActivationContainer';
import { useTranslation, Trans } from 'react-i18next';
import i18n from 'i18next';
import { themeColor } from '../Theming';
import images from '../Theming/images';
import { ANALYTICS_PAGE_NAMES } from '../Common/Analytics/utils';
import { usePageViewTracking } from '../Common/Hooks';

export const HyperisePlaceholderContainer = styled.div`
  width: 100%;
  height: fit-content;
`;

const BodyContentContainer = styled.div`
  width: 100%;
  margin-top: 33px;
  margin-top: 33px;
  padding-left: 24px;
  padding-right: 24px;
`;

const StyledImage = styled.img`
  margin-top: 5px;
  margin-left: 4px;
`;

const IconContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-bottom: 23px;
`;

const IconContentDescription = styled.div`
  color: ${themeColor('white')};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  padding-top: 15px;
`;

const WhatYouNeedText = styled.div`
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 20.8px;
  margin-bottom: 11px;
  padding-top: 30px;
  text-align: center;
  color: ${themeColor('white')};
`;

const ContentItem = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 30px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const PaddingLeft = styled.div`
  padding-left: 2px;
  font-weight: bold;
`;

const PartnerNewPluginActivateTimMultiStepPartialPermissions = () => {
  usePageViewTracking(ANALYTICS_PAGE_NAMES.partially_installed_page, 'TIM');
  if (i18n.language != 'it') {
    i18n.changeLanguage('it');
  }
  const { t } = useTranslation();

  return (
    <MultiStepActivationContainer
      logo={images.tim_partial_logo?.default}
      subHeaderText="PartnerNewpluginsdkActivate.timPartialPermissionsPartiallyInstalledSubheader"
      headerText={
        'PartnerNewpluginsdkActivate.timPartialPermissionsPartiallyInstalled'
      }
      partialPageView
      bodyMarginTop={-5}
    >
      <BodyContentContainer>
        <WhatYouNeedText>
          {t(
            'PartnerNewpluginsdkActivate.timPartialPermissionsPartiallyInstalledTodo'
          )}
        </WhatYouNeedText>
        <IconContentContainer>
          <IconContentDescription>
            <ContentItem>
              <Trans
                t={t}
                i18nKey={
                  'PartnerNewpluginsdkActivate.timPartialPermissionsPartiallyInstalledGotToSettings'
                }
              >
                <PaddingLeft />
              </Trans>
              <StyledImage
                src={images.tim_settings_icon?.default}
                width={37}
                height={37}
                alt="activationSteps_1"
              />
            </ContentItem>
            <ContentItem>
              {t(
                'PartnerNewpluginsdkActivate.timPartialPermissionsPartiallyInstalledTapSafari'
              )}
              <StyledImage
                src={images.tim_safari_icon?.default}
                width={30}
                height={30}
                alt="activationSteps_1"
              />
            </ContentItem>
            <ContentItem>
              <Trans
                t={t}
                i18nKey={
                  'PartnerNewpluginsdkActivate.timPartialPermissionsPartiallyInstalledScrollDownToExtensions'
                }
              >
                <PaddingLeft />
              </Trans>
            </ContentItem>
            <ContentItem>
              {t(
                'PartnerNewpluginsdkActivate.timPartialPermissionsPartiallyInstalledSelectTim'
              )}
              <StyledImage
                src={images.tim_app_store_icon?.default}
                width={30}
                height={30}
                alt="activationSteps_1"
              />
            </ContentItem>
            <ContentItem>
              {t(
                'PartnerNewpluginsdkActivate.timPartialPermissionsPartiallyInstalledAllowAllWebsites'
              )}
              <StyledImage
                src={images.tim_switch?.default}
                width={38}
                height={25}
                alt="activationSteps_1"
              />
            </ContentItem>
          </IconContentDescription>
        </IconContentContainer>
      </BodyContentContainer>
    </MultiStepActivationContainer>
  );
};

export default PartnerNewPluginActivateTimMultiStepPartialPermissions;
